<template>
    <div class="how-work">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="how-work__content">
                        <div class="how-work__text-wrapper">
                            <TitleDescription
                                title="How It Works"
                                description="There are 3 easy steps to your store's success"
                            />
                        </div>
                        <HowWorkItem
                            :data="howWorkData"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleDescription from '@/components/Ecommerce/TitleDescription'
import HowWorkItem from './HowWorkItem'
import { howWorkData } from './howWorkData' 

export default {
    name: 'HowItWork',
    components: {
        TitleDescription,
        HowWorkItem
    },
    data() {
        return {
            howWorkData
        }
    },
}
</script>

<style lang="scss" scoped>
$background: #EDF2F7;
$how_work_bottom_gap: 88px;
$how_work_bottom_gap_mob: 111px;
$how_work_bottom_sm_gap: 48px;
$text_wrapper_top_gap: 96px;
$text_wrapper_bottom_gap: 92px;
$text_wrapper_top_gap_mob: 72px;
$text_wrapper_bottom_gap_mob: 64px;
$text_wrapper_top_sm_gap: 56px;
$text_wrapper_bottom_sm_gap: 48px;
$how_work_content_width: 1010px;

.how-work {
    --title-fontsize: 28px;
    --title-lineheight: 32px;
    --title-margin-bottom: 8px;
    --description-fontsize: 18px;
    --description-lineheight: 24px;

    --title-color: #00002D;
    --description-color: #00002D;

    @media (max-width: 576px) {
        --title-fontsize: 20px;
        --title-lineheight: 28px;
        --description-fontsize: 16px;
        --description-lineheight: 24px;
    }

    background: $background;
    padding-bottom: $how_work_bottom_gap;
    @media (max-width: 767px) {
        padding-bottom: $how_work_bottom_gap_mob;
    }
    @media (max-width: 576px) {
        padding-bottom: $how_work_bottom_sm_gap;
    }
    &__text-wrapper {
        padding-top: $text_wrapper_top_gap;
        padding-bottom: $text_wrapper_bottom_gap;
        text-align: center;
        @media (max-width: 767px) {
            padding-top: $text_wrapper_top_gap_mob;
            padding-bottom: $text_wrapper_bottom_gap_mob;
        }
        @media (max-width: 576px) {
            padding-top: $text_wrapper_top_sm_gap;
            padding-bottom: $text_wrapper_bottom_sm_gap;
        }
    }
    // &__content {
    //     width: 100%;
    //     max-width: $how_work_content_width;
    //     margin: 0 auto;
    // }
}
</style>>
